import { render, staticRenderFns } from "./low-version-modal.vue?vue&type=template&id=51125d8e&scoped=true&lang=pug&"
import script from "./low-version-modal.vue?vue&type=script&lang=js&"
export * from "./low-version-modal.vue?vue&type=script&lang=js&"
import style0 from "./low-version-modal.vue?vue&type=style&index=0&id=51125d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51125d8e",
  null
  
)

export default component.exports